module.exports = __webpack_public_path__ + "img/hz_05.ff19de04.png";